import { useQuery } from "@tanstack/react-query";
import { scholarshipsApi } from "../../../api/scholarships";
import { SCHOLARSHIPS_KEY } from "../model";

// The sponsor list is cached by useSponsors (../model); members per sponsor
export const SPONSORS_KEY = [...SCHOLARSHIPS_KEY, "sponsors"];
export const membersKey = (sponsorId) => [...SCHOLARSHIPS_KEY, "sponsor-members", sponsorId];

export { fullName } from "../model";

export const ACCOUNT_STATUSES = {
  ACTIVE: { label: "Active", color: "green" },
  SETUP_PENDING: { label: "Setting up sign-in", color: "yellow" },
  DISABLED: { label: "Disabled", color: "gray" },
};
export const accountStatusOf = (value) => ACCOUNT_STATUSES[value] ?? { label: value ?? "—", color: "gray" };

// Everyone with the scholarship-owner role who has signed in, to pick a sponsor's new member from
export const OWNERS_KEY = [...SCHOLARSHIPS_KEY, "scholarship-owners"];
export const useScholarshipOwners = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: OWNERS_KEY,
    enabled,
    queryFn: async () => (await scholarshipsApi.get("admin/scholarship-owners", { params: { page: 0, size: 100 } })).data?.content ?? [],
  });

// The scholarship owners who act for a sponsor
export const useSponsorMembers = (sponsorId) =>
  useQuery({
    queryKey: membersKey(sponsorId),
    enabled: Boolean(sponsorId),
    queryFn: async () => (await scholarshipsApi.get(`admin/sponsors/${sponsorId}/members`)).data ?? [],
  });
